import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import { getPhase, TEAMS } from "../../data/constants";
import { fmtMoney, projectCollected } from "../../lib/appUtils";
import { TrendingUp } from "lucide-react";

const isDue = (x) => x.status === "pending_invoice" || x.status === "invoiced";

export default function CollectThisMonth({ projects }) {
  const { lang } = useApp();
  const zh = lang === "zh";
  const nav = useNavigate();
  const rows = projects
    .filter((p) => p.phaseIndex < 7 && (p.payments || []).some(isDue))
    .map((p) => ({ p, due: p.payments.filter(isDue).reduce((a, x) => a + x.amount, 0) }))
    .sort((a, b) => b.due - a.due);
  const total = rows.reduce((s, r) => s + r.due, 0);
  const teamName = (id) => { const t = TEAMS.find((x) => x.id === id); return t ? (zh ? t.zh : t.name) : id || "—"; };
  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-testid="cockpit-collect-month">
      <div className="px-5 py-3 border-b border-slate-100 flex items-center gap-2">
        <TrendingUp className="h-4 w-4 text-blue-600" />
        <h3 className="font-semibold text-slate-900">{zh ? "本月需收款项目" : "Projects Needing Collection This Month"}</h3>
        <span className="text-xs text-slate-400">{rows.length} {zh ? "个项目" : "projects"}</span>
        <span className="ml-auto text-sm font-bold text-blue-600" data-testid="cockpit-collect-month-total">{fmtMoney(total)}</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500"><tr>
            <th className="text-left font-medium px-5 py-3">{zh ? "项目" : "Project"}</th>
            <th className="text-left font-medium px-4 py-3">{zh ? "小组 / 销售" : "Team / Sales"}</th>
            <th className="text-left font-medium px-4 py-3">{zh ? "阶段" : "Stage"}</th>
            <th className="text-right font-medium px-4 py-3">{zh ? "需收款" : "To Collect"}</th>
            <th className="text-right font-medium px-4 py-3">{zh ? "已收" : "Collected"}</th>
          </tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={5} className="text-center text-slate-300 py-6">—</td></tr>}
            {rows.map(({ p, due }) => {
              const ph = getPhase(p.phaseIndex);
              return (
                <tr key={p.id} data-testid={`cockpit-collect-row-${p.id}`} className="border-t border-slate-100 hover:bg-slate-50/60 cursor-pointer" onClick={() => nav(`/project/${p.id}`)}>
                  <td className="px-5 py-3"><p className="font-medium text-slate-800 max-w-[280px] truncate">{p.address}</p><p className="text-[11px] text-slate-400">{p.clientName} · {p.type}</p></td>
                  <td className="px-4 py-3 text-slate-600 text-xs">{teamName(p.team)}<span className="text-slate-400"> · {p.sales || "—"}</span></td>
                  <td className="px-4 py-3"><span className="text-xs font-medium" style={{ color: ph.color }}>{zh ? ph.zh : ph.en}</span></td>
                  <td className="px-4 py-3 text-right font-medium text-blue-600">{fmtMoney(due)}</td>
                  <td className="px-4 py-3 text-right text-green-600">{fmtMoney(projectCollected(p))}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
